import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SearchBar from './SearchBar';
import { useCart } from '../context/CartContext';
import { useTheme } from '../context/ThemeContext';

const CartIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="21" r="1" />
    <circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
  </svg>
);

const SunIcon = ({ className = '' }) => (
  <svg className={className} width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="4.2" fill="currentColor" />
    <path d="M12 2.5v2.2M12 19.3v2.2M4.58 4.58l1.55 1.55M17.87 17.87l1.55 1.55M2.5 12h2.2M19.3 12h2.2M6.13 17.87l-1.55 1.55M19.42 4.58l-1.55 1.55" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
  </svg>
);

const MoonIcon = ({ className = '' }) => (
  <svg className={className} width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M20.4 14.15A7.9 7.9 0 1 1 9.85 3.6a7.2 7.2 0 1 0 10.55 10.55Z" fill="currentColor" />
    <path d="M17.7 3.1l.45 1.25 1.25.45-1.25.45-.45 1.25-.45-1.25L16 4.8l1.25-.45.45-1.25ZM20.7 7.9l.3.82.82.3-.82.3-.3.82-.3-.82-.82-.3.82-.3.3-.82Z" fill="currentColor" />
  </svg>
);

function Header({
  showSearch, searchValue, onSearchChange, liveSearchResults,
  onFilterToggle, filterActive, filterOpen,
  filterMode, filterProducts, filterCategories, filters, onFiltersChange,
  backTo, backLabel, backNative,
}) {
  const navigate = useNavigate();
  const { cartCount, cartTotal } = useCart();
  const { isDark, toggleTheme } = useTheme();

  return (
    <header className="header">
      <div className="header-inner">
        <Link to="/" className="brand-title" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
          <img
            src="/hercles-logo.png"
            alt="Hercles Global"
            className="brand-logo"
            style={{ width: 'auto', objectFit: 'contain', marginRight: '8px', pointerEvents: 'none' }}
            draggable={false}
          />
        </Link>
        <nav className="primary-nav" aria-label="Primary navigation">
          <Link to="/">Products</Link>
          <Link to="/category/laptops">Laptops</Link>
          <Link to="/category/phones-and-tablets">Phones</Link>
          <Link to="/category/computer-accessories">Accessories</Link>
          <Link to="/category/gaming-accessories">Gaming</Link>
          <Link to="/contact">Contact</Link>
        </nav>
        {showSearch && (
          <SearchBar
            value={searchValue}
            onChange={onSearchChange}
            liveResults={liveSearchResults}
            onFilterToggle={onFilterToggle}
            filterActive={filterActive}
            filterOpen={filterOpen}
            filterMode={filterMode}
            filterProducts={filterProducts}
            filterCategories={filterCategories}
            filters={filters}
            onFiltersChange={onFiltersChange}
          />
        )}
        {backTo && (
          <Link to={backTo} className="back-link">{backLabel || '← Back'}</Link>
        )}
        {backNative && (
          <button
            className="back-link"
            onClick={() => navigate(-1)}
            style={{ background: 'none', border: 'none', cursor: 'pointer' }}
          >
            {backLabel || '← Back'}
          </button>
        )}
        <div className="header-actions">
          <button
            type="button"
            className={`theme-toggle${isDark ? ' is-dark' : ''}`}
            onClick={toggleTheme}
            aria-pressed={isDark}
            aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
            title={isDark ? 'Light mode' : 'Dark mode'}
          >
            <span className="theme-toggle-track">
              <span className="theme-toggle-icon theme-toggle-sun"><SunIcon /></span>
              <span className="theme-toggle-icon theme-toggle-moon"><MoonIcon /></span>
              <span className="theme-toggle-thumb">
                {isDark ? <MoonIcon className="theme-toggle-active-icon" /> : <SunIcon className="theme-toggle-active-icon" />}
              </span>
            </span>
          </button>
          <Link to="/cart" className="cart-widget-link">
            <span className="cart-icon-wrap">
              <CartIcon />
              {cartCount > 0 && <span className="cart-widget-count">{cartCount}</span>}
            </span>
            <span className="cart-widget-total">KES {cartTotal.toFixed(2)}</span>
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
